module.exports = __webpack_public_path__ + "static/WEDDING E&M-569-a5f9954e1a6df626df067165b7e32065.jpg";